// extracted by mini-css-extract-plugin
export default {"wrapper":"CoursesBanner_wrapper__eE0CV"};